angular.module('client-group')
    .controller('ClientGroupDialogController', function ($timeout, $rootScope, $uibModalInstance, data, toastr, ClientGroup, ClientGroupConst) {
        this.$onInit = () => {
            this.item = data
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = ClientGroup.update(this.item).$promise
            } else {
                promise = ClientGroup.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast(ClientGroupConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
